<script lang="ts" setup>
import { useAuth0 } from '@auth0/auth0-vue';
import { ref } from 'vue';

const auth0 = useAuth0();
const isLoading = ref(auth0.isLoading);
const isAuthenticated = ref(auth0.isAuthenticated);

// 各国向けデプロイでは組織ごとのサブドメインを使わないため、常に自ドメインへ戻す
const redirectUri = `${window.location.origin}/`;

if (window.location.search.includes('invitation=')) {
  const urlSearchParams = new URLSearchParams(window.location.search);

  const organization = urlSearchParams.get('organization') || '';
  const organizationName = urlSearchParams.get('organization_name') || '';

  // URLパラメータのバリデーション: 英数字・ハイフン・アンダースコアのみ許可
  if (organization && !/^[a-zA-Z0-9_-]+$/.test(organization)) {
    console.error('Invalid organization parameter');
  } else {
    localStorage.setItem('organization', organization);
  }
  if (organizationName && !/^[a-zA-Z0-9_\-\s]+$/.test(organizationName)) {
    console.error('Invalid organization_name parameter');
  } else {
    localStorage.setItem('organization_name', organizationName);
  }

  const invitation = urlSearchParams.get('invitation') ?? undefined;

  auth0.loginWithRedirect({
    authorizationParams: {
      invitation,
      // Auth0の招待受諾にはinvitationとorganizationの両方が必要
      organization: organization || undefined,
      redirect_uri: redirectUri,
    },
  });
} else if (isLoading.value || isAuthenticated.value) {
  window.location.href = redirectUri;
} else {
  // invitationが無い場合は通常のログイン処理
  auth0.loginWithRedirect();
}
</script>
